import type { AiCapabilityPage } from "../schema.js";
import { BOUND, MANAGER_ROLES } from "./_shared.js";

/**
 * `COL-BILL` (@UC0216 · @UC0465) — trang **redirect**: «thu tiền chia theo một hóa đơn» (US-E16.F1-1020…1026, lô RECEIPT-SPLIT).
 * Chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý — một câu giải thích + nút mở tab «Quản lý quỹ» (ADR-0009 bất biến 5). Chia tiền theo hóa đơn
 * là việc của SERVER (`split-preview` chia, `advanced` ghi); chat không tự cộng/chia số nào (AI-INV-2).
 *
 * Gom đủ 5 cửa của luồng vào MỘT trang vì người dùng chỉ có một việc để nói: ba cửa của màn tạo đợt (`receipt-scan` GET+POST ·
 * `split-preview` · `advanced`) và một cửa của màn chi tiết đợt (`bill-receipt`, đính ảnh một lần). Cả năm gác O/A/T ⇒ `MANAGER_ROLES`
 * (đo ở `receipt-scan.controller.ts` + `collections.controller.ts`; mời member vào đây = dẫn tới 403).
 *
 * Trạng thái `bound`, KHÔNG `live`: cờ quét ảnh hóa đơn mặc định TẮT và nút «Quét hóa đơn» đang tạm ẩn ở sheet tạo đợt
 * (`fix/create-collection-hide-bill-scan`); trang chưa qua eval nên chưa được lên menu. Câu dưới chỉ hứa đúng phần app đang có
 * (nhập tay tổng hóa đơn rồi chia) — bật lại nút quét thì sửa câu và nâng trạng thái trong cùng PR.
 */
export const COL_BILL = {
  id: "COL-BILL",
  uc: "@UC0216",
  tier: "redirect",
  status: BOUND,
  roles: MANAGER_ROLES,
  flags: [],
  slots: [],
  llm: {
    description: "Thu tiền của các thành viên chia theo một hóa đơn: nhập tổng hóa đơn, chọn người, xem cách chia rồi tạo đợt thu.",
    examples: [
      "thu tiền theo hóa đơn",
      "thu tien theo hoa don",
      "chia hóa đơn cho mọi người",
      "chia hoa don cho moi nguoi",
      "tạo đợt thu từ hóa đơn",
      "tao dot thu tu hoa don",
      "hóa đơn tiệc 2 triệu chia cho cả lớp",
      "hoa don tiec 2 trieu chia cho ca lop",
    ],
  },
  screen: "/groups/:groupId/collections",
  screenShows: "collection_create",
  endpoints: [
    "GET /funds/{fundId}/collections/receipt-scan",
    "POST /funds/{fundId}/collections/receipt-scan",
    "POST /funds/{fundId}/collections/split-preview",
    "POST /funds/{fundId}/collections/advanced",
    "POST /funds/{fundId}/collections/{collectionId}/bill-receipt",
  ],
  facts: [],
  templates: {
    redirect:
      "Mình mở tab Quản lý quỹ nhé — bấm «Thêm yêu cầu đóng quỹ», chọn «Theo hóa đơn», nhập tổng hóa đơn và chọn người cùng chia. App sẽ chia sẵn cho bạn xem trước khi tạo; cần chỉnh số của từng người thì sửa ngay ở bước đó.",
  },
  journey: { after: ["READ-COLLECTIONS"] },
  help: { title: "Thu tiền theo hóa đơn", tryNow: "thu tiền theo hóa đơn" },
} satisfies AiCapabilityPage;
